import store from '../../store'
import router from '../../router'
import DashboardOverview1 from "../../pages/DashboardOverview1.vue";
import ErrorPage from "../../pages/ErrorPage.vue";
import NotAuthorized from "../../pages/NotAuthorized.vue";
import Modal from "../../pages/Modal.vue";
import Empty from "../../pages/Empty.vue";
import { Menu } from "../../ts/interfaces/menu.interface"
import { Route } from "../../ts/interfaces/route.interface"

import MainView from '@/views/Main.vue'
import Print from '@/views/Print.vue'

export async function setRoutes() {
  const appRoutes = recAddRoutes(store.state.menu);
  //addAppRoutes(appRoutes, path);
  //@ts-ignore
  addSubAppViewDynamic(appRoutes.map(route => route.path));
}
export async function addMenuRoutes(routes: Array<string>) {
  let extraRouteCount = 0;
  const existingRoutes = router.getRoutes();
  const existingPaths = existingRoutes.map((a: { path: string; }) => a.path);
  routes.forEach(element => {
    if (element != null && element != undefined && !existingPaths.includes(element)) {
      const routeToAdd = {
        path: '/management/' + element,
        name: `extraroute-${extraRouteCount}`,
        component: MainView,
      }
      if (routeToAdd.path != '/management/' && routeToAdd.path != '/management/management') {
        router.addRoute(routeToAdd);
      }
      extraRouteCount++;
    }
})
}
export function addSubAppView(name: string, routes: Array<string>) {

  let numberOfRoute = 0;

  if (routes[0] != "/" && routes[0] != "/iam" && routes[4] != "/management") {
    routes.forEach(element => {
      const routeToAdd = {
        path: element,
        name: `${name}-${numberOfRoute}`,
        component: MainView,
      }
      router.addRoute('/', routeToAdd);
      numberOfRoute++;
    })
  }
}

export function addSubAppViewDynamic(routes: Array<string>) {
  const menuTypes = [
    'side-menu'
  ];
  let numberOfRoute = 0;
  const existingRoutes = router.getRoutes();
  const existingPaths = existingRoutes.map((a: { path: string; }) => a.path);
  routes.forEach(element => {
    if (element != null && element != undefined && !existingPaths.includes(`/management/${element}`)) {
      menuTypes.forEach(
        menuType => {
          const routeToAdd = {
            path: menuType === 'side-menu' ? `/management/${element}` : `/${menuType}/management/${element}`,
            name: `${menuType}-${element}-${numberOfRoute}`,
            component: import("../../pages/SubApplication.vue"),
          }
          if (routeToAdd.path != '/management/') {
            router.addRoute(menuType, routeToAdd);
          }
          numberOfRoute++;
        }
      )
    }
  })
}

export function recAddRoutes(menu: Array<Menu | 'devider'>, routes: Array<Route> = []) {
  menu.forEach(
    menuItem => {
      if (menuItem === 'devider') {
        return;
      }
      if(menuItem.rec_active_rule?.includes(",")) {
        const extraRoutes = menuItem.rec_active_rule.split(",");
        let numberOfRoute = 0;
        extraRoutes.forEach(
          extraRoute => {
          routes.push({
            path: extraRoute,
            name: menuItem.pageName + numberOfRoute,
            component: menuItem.component,
          })
          numberOfRoute++;
        }
        )
      } else {
      routes.push({
        path: menuItem.href,
        name: menuItem.pageName,
        component: menuItem.component,
      })
    }
    if (menuItem.subMenu) {
      recAddRoutes(menuItem.subMenu, routes);
    }
  }
  )

  return routes;
}

// function addAppRoutes(routes: Array<Route>, path: string) {
//   const menuTypes = [
//     'side-menu'
//   ];

//   routes.forEach(
//     route => {
//       if ([
//         'dashboard',
//         'menu-layout',
//         'side-menu-dashboard-overview-1',
//         'simple-menu-dashboard-overview-1',
//         'top-menu-dashboard-overview-1'
//       ].includes(route.name)) {
//         return;
//       }
//       if (route.component === undefined) {
//         console.error('undefined component')
//       }
//       const existingRoutes = router.getRoutes();
//       const existingPaths = existingRoutes.map((a: { path: any; }) => a.path);
//       if (!existingPaths.includes(`/${path}/${route.path}`)) {
//         const Component = () => import(`../../pages/${route.component}.vue`);

//         menuTypes.forEach(
//           menuType => {
//             const routeToAdd = {
//               path: menuType === 'side-menu' ? `/${path}/${route.path}` : `/${path}/${menuType}/${route.path}`,
//               name: `${menuType}-${route.name}`,
//               component: Component,
//             }
//             router.addRoute(menuType, routeToAdd);
//           }
//         )

//       }
//     }
//   )
// }
export function updateRoutes() {
  const routes = [
    {
      path: "/",
      name: "redirect",
      redirect: "management",
    },
    {
      path: "/management",
      name: "side-menu",
      component: MainView,
      children: [
        {
          path: "/management",
          name: "side-menu-dashboard-overview-1",
          component: DashboardOverview1,
        },
        {
          path: "modal",
          name: "side-menu-modal",
          component: Modal,
        },
      ],
    },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage,
  },
  {
    path: "/management/not-authorized",
    name: "not-authorized",
    component: NotAuthorized,
  },
  {
    path: "/iam",
    name: "iam",
    component: Empty
  },
  {
    path: "/iam/register",
    name: "register",
    component: Empty
  },
  {
    path: "/iam/dev",
    name: "dev",
    component: Empty
  },
  {
    path: "/management/contact/user/:id/:pathMatch(.*)*",
    name: "profile",
    component: MainView
  },
  {
    path: "/management/risk-management",
    name: "risk-management",
    component: MainView
  },
  {
    path: "/management/risk-management/:pathMatch(.*)*",
    name: "risk-management-dynamic",
    component: MainView
  },
  {
    path: "/management/inbox",
    name: "inbox",
    component: MainView
  },
  {
    path: "/iam/dev",
    name: "dev",
    component: Empty
  },
  {
    path: "/management/knowledge",
    name: "knowledge",
    component: MainView
  },
  {
    path: "/management/eagente",
    name: "eagentemain",
    component: MainView
  },
  {
    path: "/management/knowledge/:pathMatch(.*)*",
    name: "knowledge-dynamic",
    component: MainView
  },
  {
    path: "/print/pdf",
    name: "print",
    component: Print
  },
  {
    path: "/:pathMatch(.*)*",
    name:"catchAll",
    component: ErrorPage,
  },
];

  routes.forEach(element => {
    router.addRoute(element);
  });
}